import type {FrontendTf1Season, FrontendTf1Video, Tf1CataloguePage} from '@repo/shared/api/tf1';

import {createDataStore} from '@repo/shared-web/lib/data_store';

import {apiCall} from '@repo/website-frontend/lib/api';

interface KohLantaState {
  loading: boolean;
  data?: Tf1CataloguePage;
  error?: string;
  loadedAt?: number;
}
const catalogueStore = createDataStore<KohLantaState>({loading: false});
export const useKohLantaCatalogue = catalogueStore.useData;
let pending: Promise<void> | undefined;

export function fetchKohLantaCatalogue(): Promise<void> {
  if (pending) return pending;
  catalogueStore.updateData(current => ({...current, loading: true, error: undefined}));
  pending = (async () => {
    try {
      const seasons = new Map<string, FrontendTf1Season>();
      const videos = new Map<string, FrontendTf1Video>();
      const seen = new Set<string>();
      let paginationToken: string | undefined;
      let page: Tf1CataloguePage;
      do {
        page = await apiCall('POST /list-koh-lanta', {paginationToken});
        for (const season of page.seasons) seasons.set(season.id, season);
        for (const video of page.videos) videos.set(video.videoId, video);
        paginationToken = page.paginationToken;
        if (paginationToken) {
          if (seen.has(paginationToken) || seen.size >= 100)
            throw new Error('Catalogue pagination did not finish');
          seen.add(paginationToken);
        }
      } while (paginationToken);
      catalogueStore.setData({
        loading: false,
        data: {...page, seasons: [...seasons.values()], videos: [...videos.values()]},
        loadedAt: Date.now(),
      });
    } catch (error) {
      catalogueStore.updateData(current => ({
        ...current,
        loading: false,
        error: 'Could not refresh Koh-Lanta. Try again.',
      }));
      throw error;
    } finally {
      pending = undefined;
    }
  })();
  return pending;
}
